//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.ToolAxisInterpolate.js";
let d=[[[0,"ApplyLeadTilt",1,0],[0,"MinimumLeadAngle",1,0],[0,"SmoothingMethod",1,0],[0,"TiltAngle",1,0]],[[["inputIndex","point","view","vector"],"Insert",{},4,0],[["index","point","vector"],"Modify",{},3,0],[["index","point","vector","ignorePoint"],"Modify1",{},4,0],[["index"],"Erase",{},1,0],[["index"],"MoveUp",{},1,0],[["index"],"MoveDown",{},1,0],[["index"],"GetVector",{R_:{vector:"Direction"}},1,0],[["index"],"GetLeadAngle",{R_:{leadAngle:''}},1,0],[["index","leadAngle"],"SetLeadAngle",{},2,0],[["index"],"GetTiltAngle",{R_:{tiltAngle:''}},1,0],[["index","tiltAngle"],"SetTiltAngle",{},2,0],[[],"GetPreviewMaximumDistanceBuilder",{R_:{distBuilder:"CAM.InheritableToolDepBuilder"}},0,0]],[]];
SPLM.CAM.InterpolateVector = class extends SPLM.CAM.ToolAxisInterpolate{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.InterpolateVector";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;